import browserHydrateFunction from './src/utilities/browser-hydrate-function';

export const replaceHydrateFunction = browserHydrateFunction;